module.exports = __webpack_public_path__ + "img/oneList4_new.dce0aaf2.png";